<template>
  <div id="dashboard" style="">
    <router-view />
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
#dashboard {
  position: absolute; top:0; left: 0; width:100%; height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue